module.exports = __webpack_public_path__ + "img/back_h.ea806dcc.png";